var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"photos"}},[_c('p',[_vm._v("Photos")]),_vm._v(" "),_c('div',{staticClass:"card-columns"},_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.dateAdded,staticClass:"card card-image-top imgContain align-middle"},[_c('img',{staticClass:"card-img-top",attrs:{"src":photo.url}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce96435c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photos.vue
// module id = null
// module chunks = 